import { useQuery } from '@tanstack/react-query';
import { LogzioTheme } from '@logz-pkg/enums';
import { themeService } from 'ui/components/App/theme.service';

export const useThemeInitialization = () => {
  return useQuery<LogzioTheme>({
    queryKey: ['themeInitialization'],
    queryFn: () => themeService.initializeTheme(),
  });
};
